import { Injectable } from '@angular/core';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { AlertController, Platform } from '@ionic/angular';
import { last } from 'rxjs/operators';
import packageJson from  'package.json';

@Injectable({
    providedIn: 'root'
})
export class VersionService {

    private currentVersion: string = packageJson.version;
    private version_play_store: string;
    private version_app_store: string;
    private version_desktop: string;

    constructor(
        private remoteConfig: AngularFireRemoteConfig,
        private appVersion: AppVersion,
        private alertCtrl: AlertController,
        private inAppBrowser: InAppBrowser,
        private platform: Platform
    ) {

        this.platform.ready().then(() => {
            if (this.platform.is("cordova")) {
                this.appVersion
                    .getVersionNumber()
                    .then((res) => {
                        console.log("appVersion getVersionNumber", res)
                        this.currentVersion = res;
                    })
                    .catch((error) => {
                        alert(error);
                    });
            }
        });
    }


    promptNewVersion(): void {
        console.log('New Version is now available');


        this.alertCtrl
            .create({
                header: "Une nouvelle version est disponible",
                message: "Met à jour Reussys pour profiter des dernières fonctionnalités",
                buttons: [
                    {
                        text: "Rester sur ma version",
                    },
                    {
                        text: "Mettre à jour",
                        handler: () => {
                            this.openStore();
                        },
                    },
                ],
            })
            .then((res) => {
                res.present();
            });
    }

    openStore() {
        let url = "https://appie.netlify.app/";
        if (this.platform.is('android')) {

            url = "https://play.google.com/store/apps/details?id=com.reussys.appie";
        }
        else if (this.platform.is('ios')) {
            url = "https://apps.apple.com/FR/app/appie/id1598943667";
        }

        this.inAppBrowser.create(url, '_system');
    }
    isOldVersion(version_store) {
        console.log(this.currentVersion)
        return version_store > this.currentVersion
    }

    checkVersionUpdate() {
        console.log(this.currentVersion, this.getVersions());
        if (this.platform.is('android') && this.isOldVersion(this.version_play_store)) {
            console.log("update android", this.version_play_store, this.currentVersion);
            this.promptNewVersion();
        }
        if (this.platform.is('ios') && this.isOldVersion(this.version_app_store)) {
            console.log("update ios", this.version_app_store, this.currentVersion);
            this.promptNewVersion();
        }
        if (!this.platform.is('cordova') && this.isOldVersion(this.version_desktop)) {
            console.log("update desktop", this.version_desktop, this.currentVersion);
            this.promptNewVersion();
        }
    }

    getVersions() {
        return {
            currentVersion: this.currentVersion,
            version_play_store: this.version_play_store,
            version_app_store: this.version_app_store,
            version_desktop: this.version_desktop,
        }
    }



    remoteConfigInit(): void {
        // Remote Configs for version control
        this.remoteConfig.activate();
        this.remoteConfig.strings.version_app_store.pipe(last()).subscribe(
            (version) => {
                console.log("remoteConfigInit version_app_store", version)
                this.version_app_store = version;

                this.remoteConfig.strings.version_play_store.pipe(last()).subscribe(
                    (version) => {
                        console.log("remoteConfigInit version_play_store", version)
                        this.version_play_store = version;

                        this.remoteConfig.strings.version_desktop.pipe(last()).subscribe(
                            (version) => {
                                console.log("remoteConfigInit version_desktop", version)
                                this.version_desktop = version;
                            }
                        );
                    }
                );
            }
        );
    }


}
